export default {
  POST_ADDITIONAL_MATERIAL: 'POST_ADDITIONAL_MATERIAL',
  GET_ADDITIONAL_MATERIAL: 'GET_ADDITIONAL_MATERIAL',
  PATCH_MATERIAL: 'PATCH_MATERIAL',
}
